import React, { createContext, useState, useContext } from 'react';

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [youtubeResults, setYoutubeResults] = useState([]);
  const [externalEmbed, setExternalEmbed] = useState(null);

  const updateSearchQuery = (query) => {
    setSearchQuery(query);
  };

  const updateYoutubeResults = (results) => {
    setYoutubeResults(results);
  };

  const clearSearch = () => {
    setSearchQuery('');
    setIsSearching(false);
    setYoutubeResults([]);
    setExternalEmbed(null);
  };

  const setEmbedType = (type) => {
    setExternalEmbed(type);
  };

  const clearEmbedType = () => {
    setExternalEmbed(null);
  };

  return (
    <SearchContext.Provider
      value={{
        searchQuery,
        isSearching,
        youtubeResults,
        updateSearchQuery,
        setIsSearching,
        updateYoutubeResults,
        clearSearch,
        externalEmbed,
        setEmbedType,
        clearEmbedType,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => useContext(SearchContext);